<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="card search-card">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <div class="form-row">
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">招募期限</label>
                <date-picker
                  class="w-100"
                  type="date"
                  range
                  placeholder="YYYY-MM-DD~YYYY-MM-DD"
                  v-model="dueDateRange"
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="ManpowerDemandNo">職缺編號</label>
                <input
                  type="text"
                  class="form-control"
                  id="ManpowerDemandNo"
                  placeholder="請輸入關鍵字"
                  v-model.trim="opening.ManpowerDemandNo"
                  @keyup.enter="
                    getOpening({
                      page: 1,
                      perPage: tableInfo.perPage,
                    })
                  "
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="ManpowerDemandName">職缺名稱</label>
                <input
                  type="text"
                  class="form-control"
                  id="ManpowerDemandName"
                  placeholder="請輸入關鍵字"
                  v-model.trim="opening.ManpowerDemandName"
                  @keyup.enter="
                    getOpening({
                      page: 1,
                      perPage: tableInfo.perPage,
                    })
                  "
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">{{ i18n("Position.PositionName") }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="PositionName"
                  placeholder="請輸入關鍵字"
                  v-model.trim="opening.PositionName"
                  @keyup.enter="
                    getOpening({
                      page: 1,
                      perPage: tableInfo.perPage,
                    })
                  "
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">{{ i18n("Basic.ApplyDepartment") }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="DemandDepartment"
                  placeholder="請輸入關鍵字"
                  v-model.trim="opening.DemandDepartment"
                  @keyup.enter="
                    getOpening({
                      page: 1,
                      perPage: tableInfo.perPage,
                    })
                  "
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="Applicant">{{ i18n("Basic.ApplyUser") }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="Applicant"
                  placeholder="請輸入關鍵字"
                  v-model.trim="opening.Applicant"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-3">
              <button
                type="button"
                class="btn btn-primary btn-search"
                style="margin-top: 30px; margin-left: 10px"
                @click="
                  handleSubmit(
                    getOpening({
                      page: 1,
                      perPage: tableInfo.perPage,
                    })
                  )
                "
              >
                {{ i18n("Buttons.Search") }}
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                style="margin-top: 30px; margin-left: 10px"
                @click="
                  opening = {
                    ManpowerDemandNo: null,
                    PositionName: null,
                    DemandDepartment: null,
                    Applicant: null,
                    RecruitmentStatus: null,
                    RecruitmentDeadlineStart: null,
                    RecruitmentDeadlineEnd: null,
                  };
                  dueDateRange = [];
                "
              >
                清除
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <div class="yahome-table-wrap">
      <el-table
        :data="rows"
        height="450px"
        style="width: 100%"
        @sort-change="sortChange"
      >
        <el-table-column
          prop="ManpowerDemandName"
          label="職缺名稱"
          width="350"
          header-align="center"
          fixed
          sortable="custom"
        >
          <template slot-scope="props">
            <el-tooltip class="item" effect="light" placement="top">
              <div slot="content">
                招募期限：{{
                  $common.dateFormatter(props.row.RecruitmentDeadline)
                }}<br />
                需求單：{{ props.row.ManpowerDemandNo }}<br />{{
                  props.row.ManpowerDemandName
                }}
              </div>

              <button
                type="button"
                class="btn btn-primary btn-sm btn-file"
                @click="viewDemand(props.row.ManpowerDemandNo)"
              >
                <!-- {{ props.row.ManpowerDemandNo }} -->
                <span
                  style="
                    display: block;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    width: 293px;
                    white-space: nowrap;
                  "
                >
                  {{ props.row.ManpowerDemandName }}
                </span>
              </button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="160"
          prop="DemandNumber"
          :label="i18n('DemandApply.DemandNumber')"
          sortable="custom"
        />
        <el-table-column
          header-align="center"
          align="center"
          prop="ApplicantTime"
          :label="i18n('Basic.ApplyDate')"
          sortable="custom"
          width="220"
        >
          <template slot-scope="props">
            <span>{{ $common.dateFormatter(props.row.ApplicantTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="DemandDepartment"
          min-width="180"
          :label="i18n('Basic.ApplyDepartment')"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="Applicant"
          min-width="180"
          :label="i18n('Basic.ApplyUser')"
          sortable="custom"
        />
        <el-table-column
          header-align="center"
          width="380"
          prop="recruitStatus"
          :label="i18n('Basic.RecruitStatus')"
        >
          <template slot-scope="props">
            <div class="recruit-status">
              <!-- 履歷數量 -->
              <button
                type="button"
                class="status resume_list"
                @click="goResumeList(props.row)"
              >
                <span>{{ i18n("StatusBar.ResumeList") }}</span>
                <div class="count">{{ props.row.ResumeCount }}</div>
              </button>

              <!-- 待面談 -->
              <button
                type="button"
                class="status interviewing"
                @click="goInterviewing(props.row)"
              >
                <span>{{ i18n("StatusBar.WaitInterview") }}</span>
                <div class="count">{{ props.row.WaitInterviewCount }}</div>
              </button>

              <!-- 已面談 -->
              <button
                class="status interviewed"
                @click="goInterviewed(props.row)"
              >
                <span>{{ i18n("StatusBar.Interviewed") }}</span>
                <div class="count">{{ props.row.InterviewedCount }}</div>
              </button>

              <!-- 面談未到 -->
              <button
                class="status not_arrived"
                @click="goDeclineInterview(props.row)"
              >
                <span>{{ i18n("StatusBar.DeclineInterview") }}</span>
                <div class="count">
                  {{ props.row.InterviewNotArrivedCount }}
                </div>
              </button>

              <!-- 面談結果 -->
              <button
                class="status interview_result"
                @click="goInterviewResult(props.row)"
              >
                <span>{{ i18n("StatusBar.InterviewResult") }}</span>
                <div class="count">{{ props.row.InterviewResultCount }}</div>
              </button>

              <!-- 任用結果 -->
              <button
                class="status appoint_result"
                @click="goAppointResult(props.row)"
              >
                <span>{{ i18n("StatusBar.AppointResult") }}</span>
                <div class="count">{{ props.row.AppointmentResultCount }}</div>
              </button>

              <!-- 進度 -->
              <div class="progress-style">
                <el-progress
                  type="circle"
                  :percentage="
                    Number(props.row.ProcessPercent) > 100
                      ? 100
                      : Number(props.row.ProcessPercent)
                  "
                  :stroke-width="12"
                ></el-progress>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="sizes,prev, pager, next,jumper, ->, total, slot"
        :total="totalData"
        :page-size="5"
        :page-sizes="[5, 10, 20, 50]"
        :current-page.sync="tableInfo.page"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>

    <!-- 檢視需求單 -->
    <DemandDetailModal />

    <!-- 顯示 QRCode -->
    <div id="QRCodeModal" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div
            style="
              display: block;
              text-align: center;
              color: #fff;
              padding: 20px;
            "
          >
            QR Code
          </div>
          <div class="modal-body">
            <template>
              <qrcode-vue
                :value="QRCode"
                :size="size"
                class="qrcode-wrap"
                level="H"
              />
            </template>
            <div style="margin-top: 5px">
              <input
                v-if="QRCode"
                id="copyText"
                type="text"
                size="5"
                style="opacity: 0"
                v-model="QRCode"
              />
              <br />
              <button
                ref="copyButton"
                style="background: inherit; border: none; margin-bottom: 25px"
                data-clipboard-target="#copyText"
                @click="initClipboard"
              >
                <span :class="{ copy_text: isCopy }" style="color: #fff">
                  {{ i18n("Basic.CopyLink") }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import QrcodeVue from "qrcode.vue";
import { config } from "@/components/back/table_config.js";
// 複製
import Clipboard from "clipboard";
import DemandDetailModal from "@/components/back/Modal/DemandDetail";

export default {
  name: "OpeningManage",

  components: {
    QrcodeVue,
    // Clipboard,
    DemandDetailModal,
  },
  data() {
    return {
      // 複製
      isCopy: false,
      clipboard: null,

      search: false,
      QRCode: "",
      size: 300,

      // 招募期限
      dueDateRange: [],

      opening: {
        ManpowerDemandNo: null,
        PositionName: null,
        DemandDepartment: null,
        Applicant: null,
        RecruitmentStatus: null,
        RecruitmentDeadlineStart: null,
        RecruitmentDeadlineEnd: null,
      },

      rows: [],
      totalData: 0,

      // table data
      tableInfo: {
        // 分頁資訊
        page: 1,
        perPage: 5,
      },

      columns: [
        {
          label: "QRCode",
          name: "QRCode",
          slot_name: "QRCode",
        },
        {
          label: "需求單",
          name: "ManpowerData",
          slot_name: "ManpowerData",
        },
        {
          label: this.i18n("Position.PositionName"),
          name: "PositionName",
        },
        {
          label: this.i18n("DemandApply.DemandNumber"),
          name: "DemandNumber",
        },
        {
          label: this.i18n("Basic.ApplyDate"),
          name: "ApplicantTime",
          slot_name: "ApplicantTime",
        },
        {
          label: this.i18n("Basic.ApplyDepartment"),
          name: "DemandDepartment",
        },
        {
          label: this.i18n("Basic.ApplyUser"),
          name: "Applicant",
        },
        {
          label: this.i18n("Basic.RecruitStatus"),
          name: "recruitStatus",
          slot_name: "recruitStatus",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },

      currentSort: {
        prop: null,
        order: null,
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  methods: {
    // QRCode 複製連結
    initClipboard() {
      //成功
      this.clipboard.on("success", () => {
        this.isCopy = true;
      });
      this.isCopy = false;
    },

    // 檢視需求單
    viewDemand(demandNo) {
      this.$store.commit("OpenDemandDetailModal", demandNo);
    },

    // table 分頁
    onChangeQuery(queryParams) {
      const vm = this;
      vm.tableInfo = queryParams;
      vm.getOpening({
        page: vm.tableInfo.page,
        perPage: vm.tableInfo.perPage,
      });
    },

    // el-table 分頁
    handleCurrentChange(currentPage) {
      const vm = this;
      vm.tableInfo.page = currentPage;

      vm.getOpening({
        page: vm.tableInfo.page,
        perPage: vm.tableInfo.perPage,
      });
    },

    handleSizeChange(val) {
      const vm = this;
      vm.tableInfo.perPage = val;

      vm.handleCurrentChange(1);
    },

    // 取得職缺管理 API
    getOpening({ page, perPage }) {
      const vm = this;
      vm.tableInfo.page = page;
      const api = `${window.endpoints.api}/Recruitment/paging`;

      const params = {
        ...vm.opening,
        RecruitmentDeadlineStart:
          vm.dueDateRange.length < 1 || vm.dueDateRange[0] === null
            ? null
            : vm.$common.dateFormatter(vm.dueDateRange[0]),
        RecruitmentDeadlineEnd:
          vm.dueDateRange.length < 1 || vm.dueDateRange[1] === null
            ? null
            : vm.$common.dateFormatter(vm.dueDateRange[1]),
        isPaging: true,
        page: page,
        perPage: perPage,
        OrderProp: vm.currentSort.prop,
        Order: vm.currentSort.order,
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.rows = response.data.Datas;
            vm.totalData = response.data.Quantity;
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 履歷數量 API
    goResumeList(item) {
      const ResumeCard = {
        DemandNo: item.ManpowerDemandNo,
        DemandGuid: item.Guid,
        DemandDepartment: item.DemandDepartment,
        ResumeType: item.ResumeType,
        PositionName: item.PositionName,
      };
      localStorage.setItem("ResumeCard", JSON.stringify(ResumeCard));
      this.$router.push({
        path: "/manager/opening/resume",
        query: { did: item.ManpowerDemandNo, kind: item.ResumeType, pos: item.PositionName },
      });
    },

    // 待面談 API
    goInterviewing(item) {
      const ResumeCard = {
        DemandNo: item.ManpowerDemandNo,
        DemandGuid: item.Guid,
        DemandDepartment: item.DemandDepartment,
        ResumeType: item.ResumeType,
        PositionName: item.PositionName,
      };
      localStorage.setItem("ResumeCard", JSON.stringify(ResumeCard));
      this.$router.push({
        path: "/manager/opening/inviteinterview",
        query: { did: item.ManpowerDemandNo, kind: item.ResumeType, pos: item.PositionName },
      });
    },

    // 已面談 API
    goInterviewed(item) {
      const ResumeCard = {
        DemandNo: item.ManpowerDemandNo,
        DemandGuid: item.Guid,
        DemandDepartment: item.DemandDepartment,
        ResumeType: item.ResumeType,
        PositionName: item.PositionName,
      };
      localStorage.setItem("ResumeCard", JSON.stringify(ResumeCard));
      this.$router.push({
        path: "/manager/opening/closeinterview",
        query: { did: item.ManpowerDemandNo, kind: item.ResumeType, pos: item.PositionName },
      });
    },

    // 面談未到 API
    goDeclineInterview(item) {
      const ResumeCard = {
        DemandNo: item.ManpowerDemandNo,
        DemandGuid: item.Guid,
        DemandDepartment: item.DemandDepartment,
        ResumeType: item.ResumeType,
        PositionName: item.PositionName,
      };
      localStorage.setItem("ResumeCard", JSON.stringify(ResumeCard));
      this.$router.push({
        path: "/manager/opening/declineinterview",
        query: { did: item.ManpowerDemandNo, kind: item.ResumeType, pos: item.PositionName },
      });
    },

    // 面談結果 API
    goInterviewResult(item) {
      const ResumeCard = {
        DemandNo: item.ManpowerDemandNo,
        DemandGuid: item.Guid,
        DemandDepartment: item.DemandDepartment,
        ResumeType: item.ResumeType,
        PositionName: item.PositionName,
        MatchId: item.MatchId,
      };
      localStorage.setItem("ResumeCard", JSON.stringify(ResumeCard));
      this.$router.push({
        path: "/manager/opening/interviewresult",
        query: { did: item.ManpowerDemandNo, kind: item.ResumeType, pos: item.PositionName },
      });
    },

    // 任用結果
    goAppointResult(item) {
      const ResumeCard = {
        DemandNo: item.ManpowerDemandNo,
        DemandGuid: item.Guid,
        DemandDepartment: item.DemandDepartment,
        ResumeType: item.ResumeType,
        PositionName: item.PositionName,
        MatchId: item.MatchId,
      };
      localStorage.setItem("ResumeCard", JSON.stringify(ResumeCard));
      this.$router.push({
        path: "/manager/opening/evaluationresult",
        query: { did: item.ManpowerDemandNo, kind: item.ResumeType, pos: item.PositionName },
      });
    },

    // 顯示 QRCode
    showQRCode() {
      this.isCopy = false;
      const url = window.location.origin;
      if (this.$cookies.get("candidateId")) {
        this.$common.checkConsentForm();
      } else {
        this.QRCode = `${url}/#/signIn`;
      }
    },

    sortChange(column) {
      const vm = this;
      console.log(column);
      vm.currentSort = { ...column };
      vm.getOpening({
        page: vm.tableInfo.page,
        perPage: vm.tableInfo.perPage,
      });
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  mounted() {
    this.clipboard = new Clipboard(this.$refs.copyButton);
  },

  activated() {
    this.getOpening({
      page: this.tableInfo.page,
      perPage: this.tableInfo.perPage,
    });
  },

  created() {
    this.getOpening({
      page: this.tableInfo.page,
      perPage: this.tableInfo.perPage,
    });
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .opening-table tr td {
  vertical-align: middle;
}

/deep/ .el-table th.is-leaf {
  border-bottom: 0;
}

/deep/ .el-table::before {
  background: inherit;
}

// 進度Circle
/deep/ .progress-style {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  .el-progress-circle {
    height: 53px !important;
    width: 53px !important;
  }
}

.copy_text {
  animation: 0.3s blink 1 steps(1);
}
@keyframes blink {
  50% {
    color: transparent;
  }
}
//狀態列
.recruit-status {
  .status {
    border-radius: 50%;
    border: none;
    width: 40px;
    height: 40px;
    background-size: 80%;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    display: inline-block;
    vertical-align: middle;
    background-color: #d7e6ff;
    margin-left: 7px;
    transition: all 0.2s;
    top: 0;

    &:hover {
      top: -5px;
      span {
        opacity: 1;
        background-color: #303c50;
        color: #fff;
        border-radius: 5px;
        padding: 2px 5px;
      }
    }

    span {
      font-size: 10px;
      position: absolute;
      bottom: -10px;
      transform: translateX(-50%);
      text-align: center;
      left: 50%;
      opacity: 0;
      z-index: 100;
      white-space: nowrap;
    }
    .count {
      position: absolute;
      right: -7px;
      bottom: -5px;
      background-color: red;
      width: 29px;
      height: 29px;
      color: #fff;
      border-radius: 50%;
      font-size: 12px;
      line-height: 29px;
      text-align: center;
      transform: scale(0.8);
    }

    &.resume_list {
      background-image: url("~@/assets/img/job_states/resume.png");
    }
    &.interviewing {
      background-image: url("~@/assets/img/job_states/interviewed.png");
    }
    &.interviewed {
      background-image: url("~@/assets/img/job_states/interviewing.png");
    }
    &.not_arrived {
      background-image: url("~@/assets/img/job_states/alternative.png");
    }

    &.interview_result {
      background-image: url("~@/assets/img/job_states/second-view.png");
    }

    &.appoint_result {
      background-image: url("~@/assets/img/job_states/hired.png");
    }

    &.days {
      background-image: url("~@/assets/img/job_states/days.png");
    }
  }
}

#QRCodeModal {
  .modal-content {
    background-color: rgba(0, 0, 0, 0.6);
    .modal-header,
    .modal-footer {
      border: none;
      color: #fff;
      display: block;
      text-align: center;
    }
    .modal-header:after {
      background-color: none;
    }
    .modal-body {
      text-align: center;
      .qrcode-wrap {
        display: inline-block;
        background-color: #fff;
        padding: 10px;
        border-radius: 5px;
      }
    }
  }
  img {
    width: 100%;
  }
}
</style>
